import React, { useCallback, useContext, useMemo } from 'react';
import { Stack, Text } from '@chaser/components';
import MappingTableRow from '../../TableRow';
import format from 'date-fns-tz/format';
import ChaserStyledSelect from '../../../../../../components/ChaserStyledSelect';
import { SupportedDateFormatsContext } from '../../../Configure/supportedDateFormatsContext';
import { MappingTypeSimpleBase } from '../Simple';
import { useReadOnly } from '../../readOnlyContext';

export const getConsumedColumns = value => {
  return {
    [value?.columnId]: true,
  };
};

export const MappingTypeDateFormatSelect = ({
  value,
  onChange,
  containerStyles,
  hideDefault,
  name,
}) => {
  const supportedDateFormats = useContext(SupportedDateFormatsContext);

  const dateFormats = useMemo(() => {
    const example = new Date('2024-10-22T16:30:00');
    const formats = supportedDateFormats.map(({ dateFnsFormat }) => ({
      value: dateFnsFormat,
      label: (
        <Stack gap="xxsmall">
          {dateFnsFormat}
          <Text fontSize="xsmall" color="Mid Neutral 1">
            ({format(example, dateFnsFormat)})
          </Text>
        </Stack>
      ),
      selectedLabel: dateFnsFormat,
    }));

    if (!hideDefault) {
      formats.unshift({
        value: 'DEFAULT',
        label: 'Default',
        selectedLabel: 'Default',
      });
    }

    return formats;
  }, [hideDefault, supportedDateFormats]);

  const selectedDateFormat = useMemo(
    () => dateFormats.find(({ value: v }) => v === (value || 'DEFAULT')),
    [value, dateFormats],
  );

  const handleOnChange = useCallback(
    value => {
      onChange({
        target: {
          name,
          value: value.value,
        },
      });
    },
    [onChange, name],
  );

  const readOnly = useReadOnly();

  return (
    <ChaserStyledSelect
      value={selectedDateFormat}
      onChange={handleOnChange}
      options={dateFormats}
      containerStyles={containerStyles}
      name={name}
      isDisabled={readOnly}
    />
  );
};

const MappingTypeDate = ({ field, value, availableColumns, onChange }) => {
  const handleOnChange = useCallback(
    patch => {
      onChange(patch ? { format: 'DEFAULT', ...value, ...patch } : null);
    },
    [onChange, value],
  );

  return (
    <>
      <MappingTableRow field={field}>
        <MappingTypeSimpleBase
          value={value}
          availableColumns={availableColumns}
          onChange={handleOnChange}
          required={field.required}
        />
      </MappingTableRow>

      {value?.columnId && (
        <MappingTableRow
          field={{
            name: 'Date format',
          }}
          isNested
        >
          <MappingTypeDateFormatSelect
            value={value?.format}
            onChange={({ target: { value: v } }) => handleOnChange({ format: v })}
          />
        </MappingTableRow>
      )}
    </>
  );
};

export const Component = MappingTypeDate;
